import { MessageBox } from "element-ui";

export const getTableHeight = (el) => {
    if (!el) return
    /**@type {HTMLElement} */
    let p = el.parentElement
    let h = p.clientHeight;
    for (let children of el.parentElement.children) {
        const info = getComputedStyle(children);
        const pt = parseFloat(info.paddingTop),
            pb = parseFloat(info.paddingBottom),
            mt = parseFloat(info.marginTop),
            mb = parseFloat(info.marginBottom),
            h2 = parseFloat(info.height),
            bt = parseFloat(info.borderTopWidth),
            bb = parseFloat(info.borderBottomWidth);
        if (
            ![...children.classList].includes("el-table") &&
            children.style.display != "none"
        ) {
            h -= pt + pb + mt + mb + h2 + bt + bb;
        }
    }
    return h;
}

/**
 * 
 * @param {*} h  this.$createElement
 * @param {*} param1 
 * @returns 
 */
export const getEditDeleteBtns = (h, {
    editCb, deleteCb
}) => {
    return {
        label: '操作',
        prop: 'cz',
        width: '200',
        formatter(row) {
            return [
                h('ElButton', {
                    props: {
                        type: 'text',

                    },
                    on: {
                        click() {
                            editCb(row)
                        }
                    }
                }, '编辑'),
                h('ElButton', {
                    props: {
                        type: 'text',
                    },
                    on: {
                        click() {
                            MessageBox.confirm('是否删除该数据', '温馨提示', {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                type: 'warning'
                            }).then(() => {
                                deleteCb(row)
                            })
                        }
                    }
                }, '删除')
            ]
        }
    }


}

export const getEditDeleteBtns2 = (h, params = { editCb, deleteCb, isEdit, isDel, delMsg }) => {
    if (!params.hasOwnProperty('isEdit')) {
        params.isEdit = true
    }
    if (!params.hasOwnProperty('isDel')) {
        params.isDel = true
    }

    if (!params.delMsg) {
        params.delMsg = '是否删除该数据'
    }

    return [
        params.isEdit ? h('ElButton', {
            props: {
                type: 'text',
            },
            on: {
                click() {
                    params.editCb()
                }
            }
        }, '编辑') : null,
        params.isDel ? h('ElButton', {
            props: {
                type: 'text',
            },
            on: {
                click() {
                    MessageBox.confirm(params.delMsg, '温馨提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        params.deleteCb()
                    })
                }
            }
        }, '删除') : null
    ]
}


// WEBPACK FOOTER //
// ./src/components/easyTable/config.js